import { Flex } from '@raystack/apsara';

import styles from './TypingLoader.module.css';

export const TypingLoader = () => {
  return (
    <Flex className={styles.dots} align='center' justify='start'>
      <div className={styles.dot1} />
      <div className={styles.dot2} />
      <div className={styles.dot3} />
    </Flex>
  );
};
